var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPresentiel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0722 35.8437C34.3611 33.819 33.0398 32.0646 31.2901 30.8222C29.5404 29.5797 27.4486 28.9103 25.3026 28.9062H25.2934C23.1476 28.9102 21.0559 29.5795 19.3064 30.822C17.557 32.0645 16.236 33.819 15.5254 35.8437",
    stroke: "#7E8EAA",
    strokeWidth: 2.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8125 17.0061C21.3038 18.5505 23.23 19.6042 25.3348 20.0272C27.4396 20.4502 29.6233 20.2224 31.5955 19.3741",
    stroke: "#7E8EAA",
    strokeWidth: 2.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9336 20.2344C18.9336 21.0695 19.0981 21.8964 19.4177 22.668C19.7373 23.4396 20.2057 24.1406 20.7962 24.7311C21.3867 25.3217 22.0878 25.7901 22.8593 26.1097C23.6309 26.4293 24.4578 26.5937 25.293 26.5937C26.1281 26.5937 26.955 26.4293 27.7266 26.1097C28.4982 25.7901 29.1992 25.3217 29.7897 24.7311C30.3802 24.1406 30.8487 23.4396 31.1683 22.668C31.4879 21.8964 31.6523 21.0695 31.6523 20.2344C31.6523 19.3992 31.4879 18.5723 31.1683 17.8007C30.8487 17.0292 30.3802 16.3281 29.7897 15.7376C29.1992 15.1471 28.4982 14.6787 27.7266 14.3591C26.955 14.0395 26.1281 13.875 25.293 13.875C24.4578 13.875 23.6309 14.0395 22.8593 14.3591C22.0878 14.6787 21.3867 15.1471 20.7962 15.7376C20.2057 16.3281 19.7373 17.0292 19.4177 17.8007C19.0981 18.5723 18.9336 19.3992 18.9336 20.2344V20.2344Z",
    stroke: "#7E8EAA",
    strokeWidth: 2.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1992 12.7187H14.8867V16.1875L10.2617 12.7187H3.32422C2.71091 12.7187 2.12271 12.4751 1.68903 12.0414C1.25536 11.6078 1.01172 11.0196 1.01172 10.4062V3.46875C1.01172 2.85544 1.25536 2.26724 1.68903 1.83357C2.12271 1.39989 2.71091 1.15625 3.32422 1.15625H17.1992C17.8125 1.15625 18.4007 1.39989 18.8344 1.83357C19.2681 2.26724 19.5117 2.85544 19.5117 3.46875V10.4062C19.5117 11.0196 19.2681 11.6078 18.8344 12.0414C18.4007 12.4751 17.8125 12.7187 17.1992 12.7187V12.7187Z",
    stroke: "#7E8EAA",
    strokeWidth: 2.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.418 4.625H5.63672",
    stroke: "#7E8EAA",
    strokeWidth: 2.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8867 8.09375H5.63672",
    stroke: "#7E8EAA",
    strokeWidth: 2.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85254 24.2812C3.85254 25.5079 4.33981 26.6843 5.20717 27.5516C6.07453 28.419 7.25091 28.9062 8.47754 28.9062C9.70417 28.9062 10.8806 28.419 11.7479 27.5516C12.6153 26.6843 13.1025 25.5079 13.1025 24.2812C13.1025 23.0546 12.6153 21.8782 11.7479 21.0109C10.8806 20.1435 9.70417 19.6562 8.47754 19.6562C7.25091 19.6562 6.07453 20.1435 5.20717 21.0109C4.33981 21.8782 3.85254 23.0546 3.85254 24.2812Z",
    stroke: "#7E8EAA",
    strokeWidth: 2.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5833 32.5785C11.3983 31.6934 9.95838 31.2163 8.47936 31.2188C7.04867 31.2214 5.65401 31.6677 4.48749 32.496C3.32096 33.3243 2.43995 34.4939 1.96582 35.8437",
    stroke: "#7E8EAA",
    strokeWidth: 2.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.293 28.9062V35.8437",
    stroke: "#7E8EAA",
    strokeWidth: 2.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentiel);
export default __webpack_public_path__ + "static/media/presentiel.fca8312361766c38beae3a73d99d0b53.svg";
export { ForwardRef as ReactComponent };